import { Issue } from "../common/types";
import { Box, ExpandableSection, Grid, Header, SpaceBetween } from "@cloudscape-design/components";
import { ReviewList } from "./ReviewList";
import { useMemo } from "react";
import { SimpleReviewList } from "./SimpleReviewList";
import { groupReviewsBySource } from "../common/formatting/sourceFormat";


export type IssueViewProps = {
  issue: Issue;
  placeName: string;
  issueNumber: number;
};

export function IssueView(props: IssueViewProps) {
  const issue = props.issue;
  const issueNumber = props.issueNumber;
  // sort the review links by position so position 1 is first, position 2 is second, etc.
  const sortedReviewLinks = useMemo(() => {
    return issue.review_links.sort((a, b) => {
      return a.position - b.position
    });
  }, [issue.review_links]);

  const reviews = useMemo(() => {
    return sortedReviewLinks.map((reviewLink) => reviewLink.review);
  }, [sortedReviewLinks]);

  const sourceCounts = useMemo(() => {
    return groupReviewsBySource(reviews);
  }, [reviews]);

  const sourceCountsDisplay = useMemo(() => {
    return sourceCounts.map((sc) => `${sc.count} ${sc.source}`).join(' · ');
  }, [sourceCounts]);

  const reviewCount = issue.review_links.length;
  return (
    <ExpandableSection 
      headerText={`${issueNumber}) ${issue.name}`} 
      headerDescription={issue.description ?? undefined} 
      variant="default"
      headerActions={
        <Box variant="p" color="text-body-secondary">
          {reviewCount.toLocaleString()} reviews{sourceCounts.length > 0 && ` (${sourceCountsDisplay})`}
        </Box>
      }>
      <SimpleReviewList
        reviews={reviews}
        placeName={props.placeName}
      />
    </ExpandableSection>
  );
}
